import React from "react";
import styled from "styled-components";
import {isMobile} from 'react-device-detect';

import colors from "../settings/colors"

const Header = styled.h1`
    margin-top: 0px;
    margin-bottom: 0px;

    text-align: ${isMobile ? "center":"left"};
`

function PageHeader(props) {

  return (
    <Header style={props.style}>
        {props.children}
    </Header>
  );
}

export default PageHeader;